// Resolves the dataset id for a given tnt source. Shared by the upload and snapshot-download
// paths so both resolve against the same source: pairing one source's dataset id with another's
// dataSetVersionId yields a request the backend cannot satisfy.

export type DataSetUsage = 'PROD' | 'SIMULATION';

/** Minimal shape needed to identify a dataset; every field optional so store types assign freely. */
export interface DataSetEntry {
  id?: string;
  usage?: string;
  tntSource?: { name?: string } | null;
}

export type DataSetEntries = Record<string, DataSetEntry | null | undefined>;

export const findDataSetId = (
  timeInTransitState: DataSetEntries,
  tntSourceName: string,
  usage: DataSetUsage = 'PROD',
): string | null =>
  Object.values(timeInTransitState).find((entry) => entry?.usage === usage && entry?.tntSource?.name === tntSourceName)
    ?.id ?? null;
